module.exports = __webpack_public_path__ + "static/media/holidays-icon.a357fcfc.PNG";